import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/chevron_down.png'


const _withScopeId = n => (_pushScopeId("data-v-7270fee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "center-container" }
const _hoisted_3 = { class: "wrap_signin" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "center-container" }
const _hoisted_7 = { class: "wrap_signin" }
const _hoisted_8 = { class: "wrap_next" }
const _hoisted_9 = { class: "center-container" }
const _hoisted_10 = { class: "wrap_rec_screen" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin_title" }, " 버튼을 눌러 자신의 목소리를 녹음해보세요. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin_subtitle" }, " 약 10초 정도 녹음해주세요. ", -1))
const _hoisted_13 = { class: "wrap_rec" }
const _hoisted_14 = { class: "rec" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "wrap_next" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_next" }, [
  /*#__PURE__*/_createElementVNode("div", null, "방금 녹음한 음성입니다. 마음에 들면 다음으로 넘어가주세요.")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "already" }, " 이미 계정이 있나요? ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skip" }, " 건너뛰고 로그인하기 -> ", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "center-container" }
const _hoisted_22 = { class: "wrap_signin" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin_title" }, " 당신의 목소리로 글을 읽어드릴게요. ", -1))
const _hoisted_24 = { class: "signin_title" }
const _hoisted_25 = { class: "wrap_next" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "already" }, " 마음에 드셨나요? ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skip" }, " 회원가입하고 보이스채팅 해보기 -> ", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

import {
  ref,
  onMounted,
} from 'vue';
import { guestStore } from '../stores/storeAuth';
import { useAudioStore } from '../stores/storeAudio';
import { routeHelper } from '@utils';
import { postSpeakerGuest } from '@apis/voicechat';
// import { postVoiceStreams } from '@apis/voiceStreams';
import { postStreams } from '@apis/streams';
// import { postStreamsGuest } from '@apis/streams';


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPage',
  setup(__props) {

const { pushPage } = routeHelper;
const welcomeTitle = ref<HTMLElement | null>(null);
const welcomeSubtitle = ref<HTMLElement | null>(null);
const welcomeChevron = ref<HTMLElement | null>(null);
const firstScreen = ref<HTMLElement | null>(null);
const secondScreen = ref<HTMLElement | null>(null);
const thirdScreen = ref<HTMLElement | null>(null);
const isFirstScreen = ref(true);
const isSecondScreen = ref(true);
const isThirdScreen = ref(false);
const guestData = guestStore();
const myVoice = ref(false);
const isListening = ref(false);
const guestString = ref('');
const audioPlayer = ref<HTMLAudioElement | null>(null);

const sampleText = ref('이 모든 구성이 단 삼만구천구백원! 파격적인 혜택에 사은품까지 같이 드리니까요, 얼른 전화 주세요!');
const speakerBase64Result = ref('');
let mediaRecorder: MediaRecorder | null;
let audioChunks: Blob[] = [];

// speaker guest
const speakerGuest = async (base64Data: string) => {
  const params = { audio_base64_string: base64Data };
  try {
    const result = await postSpeakerGuest(params);
    console.log(result.data.speaker_base64_string, '💛💛');
    speakerBase64Result.value = result.data.speaker_base64_string;
  } catch (error) {
    alert(error);
  }
};

// stream guest
const streamGuest = async () => {
  if (!speakerBase64Result.value) return;
  const params = {
    quest: sampleText.value,
    speaker_base64_string: speakerBase64Result.value,
  };
  try {
    // const iterator = postStreams('guest', params.quest, params.speaker_base64_string);
    // let result;
    // let i = 0;
    // do {
    //   result = iterator.next();
    //   i += 1;
    //   console.log(`iterator(${i}):`, result.value);
    // } while (!result.done);
    postStreams('guest', params.quest, params.speaker_base64_string);
  } catch (error) {
    console.log(error);
  }
};

const startRecording = () => {
  isListening.value = true;

  navigator.mediaDevices.getUserMedia({ audio: true })
    .then((stream) => {
      mediaRecorder = new MediaRecorder(stream);

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });

        const reader = new FileReader();
        reader.onloadend = async () => {
          // base64 String
          const base64String = reader.result as string;
          const base64Data = base64String.split(',')[1];
          guestString.value = base64Data;
          console.log(base64Data);

          // speaker/guest 호출
          await speakerGuest(base64Data);

          // 오디오 재생
          if (audioPlayer.value) {
            audioPlayer.value.src = base64String;
          }
        };

        reader.readAsDataURL(audioBlob);

        // 정리
        audioChunks = [];
        mediaRecorder = null;
        isListening.value = false; // 녹음이 중지될 때 isListening을 false로 설정
      };

      mediaRecorder.start();
    })
    .catch((error) => {
      console.error('마이크에 접근 중 오류 발생:', error);
      isListening.value = false;
    });
};

const stopRecording = () => {
  isListening.value = false;
  myVoice.value = true;
  if (mediaRecorder) {
    mediaRecorder.stop();
  }
};

const goSignUp = () => {
  pushPage('login');
  guestData.guestString = guestString.value;
};

// ANIMATIONS
const fadeInWelcome = () => {
  // 어서오세요 메시지 페이드 인 애니메이션
  if (welcomeTitle.value) {
    welcomeTitle.value.style.opacity = '1';
  }

  // 1초 후에 서브타이틀 페이드 인 애니메이션
  setTimeout(() => {
    if (welcomeSubtitle.value) {
      welcomeSubtitle.value.style.opacity = '1';
    }
  }, 1000);

  setTimeout(() => {
    if (welcomeChevron.value) {
      welcomeChevron.value.style.opacity = '1';
      welcomeChevron.value.style.transform = 'translateY(0)';
    }
  }, 2000);
};

const goThirdScreen = () => {
  isSecondScreen.value = false;
  setTimeout(() => {
    if (thirdScreen.value) {
      thirdScreen.value.style.opacity = '1';
      thirdScreen.value.style.transform = 'translateY(0px)';
    }
  }, 1000);
  isThirdScreen.value = true;
};

const goSecondScreen = () => {
  isFirstScreen.value = false;
  setTimeout(() => {
    if (secondScreen.value) {
      secondScreen.value.style.opacity = '1';
      secondScreen.value.style.transform = 'translateY(0px)';
    }
  }, 1000);
  isThirdScreen.value = true;
};

const handleWheel = (event: WheelEvent) => {
  // 마우스 휠 이벤트에서 deltaY 값을 확인하여 스크롤 방향을 감지합니다.
  if (event.deltaY > 0) {
    console.log('스크롤 다운 감지!');
    const handleTransitionEnd = () => {
      firstScreen.value?.removeEventListener('transitionend', handleTransitionEnd);

      isFirstScreen.value = false;
    };

    setTimeout(() => {
      if (firstScreen.value) {
        firstScreen.value.addEventListener('transitionend', handleTransitionEnd);

        // Start the animation
        firstScreen.value.style.opacity = '0';
        firstScreen.value.style.transform = 'translateY(0)';
      }
    }, 1);

    setTimeout(() => {
      isSecondScreen.value = true;
      if (secondScreen.value) {
        secondScreen.value.style.opacity = '1';
      }
    }, 1000);
  }
};

const isDesktop = ref(window.innerWidth >= 769);

// 창 크기가 변할 때마다 체크
window.addEventListener('resize', () => {
  isDesktop.value = window.innerWidth >= 769;
});

onMounted(() => {
  if (welcomeTitle.value) {
    welcomeTitle.value.style.opacity = '0';
  }
  if (welcomeSubtitle.value) {
    welcomeSubtitle.value.style.opacity = '0';
  }
  if (welcomeChevron.value) {
    welcomeChevron.value.style.opacity = '0';
    welcomeChevron.value.style.transform = 'translateY(-100px)';
  }
  if (secondScreen.value) {
    secondScreen.value.style.opacity = '0';
    secondScreen.value.style.transform = 'translateY(0px)';
  }
  if (thirdScreen.value) {
    thirdScreen.value.style.opacity = '0';
    thirdScreen.value.style.transform = 'translateY(0px)';
  }

  isSecondScreen.value = true;
  isThirdScreen.value = false;

  // 컴포넌트가 마운트된 후 0.5초 뒤에 애니메이션 시작
  setTimeout(() => {
    fadeInWelcome();
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isFirstScreen.value && isDesktop.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "firstScreen",
          ref: firstScreen,
          class: "first-screen layout",
          onWheel: handleWheel
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                ref_key: "welcomeTitle",
                ref: welcomeTitle,
                class: "signin_title"
              }, " 어서오세요 ", 512),
              _createElementVNode("div", {
                ref_key: "welcomeSubtitle",
                ref: welcomeSubtitle,
                class: "signin_subtitle"
              }, " 커스텀보이스 베타버전에 오신 것을 환영합니다. ", 512),
              _createElementVNode("div", {
                ref_key: "welcomeChevron",
                ref: welcomeChevron,
                class: "chevron"
              }, _hoisted_5, 512)
            ])
          ])
        ], 544))
      : _createCommentVNode("", true),
    (isFirstScreen.value && !isDesktop.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "firstScreen",
          ref: firstScreen,
          class: "first-screen layout",
          onWheel: handleWheel
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                ref_key: "welcomeTitle",
                ref: welcomeTitle,
                class: "signin_title"
              }, " 어서오세요 ", 512),
              _createElementVNode("div", {
                ref_key: "welcomeSubtitle",
                ref: welcomeSubtitle,
                class: "signin_subtitle"
              }, " 커스텀보이스 베타버전에 오신 것을 환영합니다. ", 512),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  ref_key: "welcomeChevron",
                  ref: welcomeChevron,
                  class: "next",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goSecondScreen()))
                }, " 시작하기 ", 512)
              ])
            ])
          ])
        ], 544))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      ref_key: "secondScreen",
      ref: secondScreen,
      class: "second-screen"
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (!isListening.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "button_rec_mic",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (startRecording()))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "rec_icon",
                      icon: "fa-solid fa-microphone"
                    })
                  ]))
                : _createCommentVNode("", true),
              (isListening.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "button_rec_stop",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (stopRecording()))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "rec_icon",
                      icon: "fa-solid fa-square"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            (isListening.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 녹음 중입니다. 정지버튼을 눌러 녹음을 완료하세요. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("audio", {
                  ref_key: "audioPlayer",
                  ref: audioPlayer,
                  controls: ""
                }, null, 512)
              ])
            ])
          ]),
          _hoisted_17,
          _createElementVNode("div", { class: "wrap_next" }, [
            _createElementVNode("div", {
              class: "next",
              onClick: goThirdScreen
            }, " NEXT ")
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "go_signup",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(pushPage)('login')))
      }, _hoisted_20)
    ], 512), [
      [_vShow, isSecondScreen.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "thirdScreen",
      ref: thirdScreen,
      class: "third-screen"
    }, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sampleText).value = $event)),
              class: "sample_text"
            }, null, 512), [
              [_vModelText, sampleText.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              class: "next",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (streamGuest()))
            }, " 들어보기 ")
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "go_signup",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (goSignUp()))
      }, _hoisted_28)
    ], 512), [
      [_vShow, isThirdScreen.value]
    ])
  ]))
}
}

})